import { styled } from 'next-yak'

import * as colors from '../constants/colors.ts'
import { Polymorphic } from '@owl-nest/yak/extra-runtime'

const ShadowBox = styled(Polymorphic.div)`
  background-color: ${colors.PRIMARY_GREY_000};
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.12),
    0 1px 2px rgba(0, 0, 0, 0.24);
`

export default ShadowBox
